export const defaultStudentFilter = {
  firstname: '',
  lastname: '',
  schoolId: null,
  username: '',
  active: 1,
  country: null,
  dni: '',
  userType: 0,
  onlyIndependent: false,
};

export const defaultTeacherFilter = {
  firstname: '',
  lastname: '',
  schoolId: null,
  username: '',
  active: 1,
  country: null,
  dni: '',
  userType: 2,
};

export const defaultSchoolFilter = {
  country: null,
  schoolName: '',
  id: null,
  active: 1,
};

export const defaultCourseSchoolFilter = {
  grades: [],
  sections: [],
};

export const defaultSchoolListParams = {
  id: '',
  baseCountry_id: '',
  name: '',
  active: '',
};

export const defaultDistrictAdminFilter = {
  search: '',
  active: null,
};

export const defaultCampusGroupAdminFilter = {
  search: '',
  active: null,
  campus_group_id: null,
};

export const defaultConglomerateFilter = {
  country: null,
  name: '',
  active: null,
};

export const defaultUsersFilter = {
  firstname: '',
  lastname: '',
  schoolId: null,
  username: '',
  active: 1,
  country: null,
  dni: '',
  userType: null,
};

export const defaultDirectiveAdminFilter = {
  search: '',
  active: null,
  country: null,
  school_id: null,
  firstname: '',
  lastname: '',
  dni: '',
};
